module.exports = __webpack_public_path__ + "static/media/sf_restaurant_18.1503eec9.jpg";